import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ClientWithID, ContactWithID } from "../../types/request.type";

type ContactInsertState = {
  contact_request: ContactWithID;
  loading: boolean;
  success: boolean;
  error: string | null;
};

export const initContactResponse: ContactWithID = {
  id: 0,
  name: "",
  client: {
    id: 0,
    title: "",
  },
  phones: [],
  emails: [],
  position: "",
  comment: "",
};
const initialState: ContactInsertState = {
  contact_request: initContactResponse,
  loading: false,
  success: false,
  error: "",
};

const contactRequestSlice = createSlice({
  name: "contact_request",
  initialState: initialState,
  reducers: {
    // Обычные редьюсеры

    setName0(state, action: PayloadAction<string>) {
      const stateNew = state;
      stateNew.contact_request!.name = action.payload;
      state = stateNew;
    },

    setClientContacts0(state, action: PayloadAction<ClientWithID>) {
      const stateNew = state;
      stateNew.contact_request!.client = action.payload;

      state = stateNew;
    },

    setPhones0(state, action: PayloadAction<string[]>) {
      const stateNew = state;
      stateNew.contact_request!.phones = action.payload;
      state = stateNew;
    },

    setEmails0(state, action: PayloadAction<string[]>) {
      const stateNew = state;
      stateNew.contact_request!.emails = action.payload;
      state = stateNew;
    },

    setPosition0(state, action: PayloadAction<string>) {
      const stateNew = state;
      stateNew.contact_request!.position = action.payload;
      state = stateNew;
    },

    setComment0(state, action: PayloadAction<string>) {
      const stateNew = state;
      stateNew.contact_request!.comment = action.payload;
      state = stateNew;
    },

    setReset0: (state) => {
      const stateNew = state;
      stateNew.contact_request = initialState.contact_request;
      state = stateNew;
    },
  },
});

export const {
  setName0,
  setClientContacts0,
  setPhones0,
  setEmails0,
  setPosition0,
  setComment0,
  setReset0,
} = contactRequestSlice.actions;

export const contactRequestReducer = contactRequestSlice.reducer;
